import type { ReactNode } from "react";
import { OtsDialog } from "../components/OtsDialog";
import type { OtsBrand, OtsColorSchemePreference } from "../theme/OtsTheme";

export type TicketAuditDialogProps = {
  open: boolean;
  onClose: () => void;
  /** Which ticket is audited, e.g. "WG-1002 · P-48219 → D-90127 · Maria Torres". */
  subtitle?: ReactNode;
  /** The audit itself; usually an `AuditPanel` or `ConnectedTicketAuditPanel`. */
  children?: ReactNode;
  /** Tighter chrome for embedded hosts such as WaterGo. Defaults to the app density. */
  compact?: boolean;
  brand?: OtsBrand;
  colorScheme?: OtsColorSchemePreference;
};

/**
 * WaterGo's Ticket Audit dialog: one ticket's audit with room to read it. Shared by Driver Activity, the
 * dashboard, and WaterGo (through the `TicketAuditDialog` bridge).
 */
export const TicketAuditDialog = ({ open, onClose, subtitle, children, compact, brand, colorScheme }: TicketAuditDialogProps) => (
  <OtsDialog
    open={open}
    onClose={onClose}
    title="Ticket Audit"
    description={subtitle ?? "Audit confidence and findings"}
    truncateDescription
    size="4xl"
    closeStyle="icon"
    divided
    compact={compact}
    brand={brand}
    colorScheme={colorScheme}>
    {children}
  </OtsDialog>
);
